import resolve from '@jridgewell/resolve-uri';

export const BASE_URL_BACKEND =
  import.meta.env.VITE_BACKEND_API_URL ?? 'http://localhost:8080';

export const MODE_DEV = import.meta.env.DEV;

export const BASE_URL_DOCS = 'https://docs.float16.cloud';
export const PATH_DOCS = {
  root: BASE_URL_DOCS,
  validatedModel:
    'https://docs.float16.cloud/getting-started/one-click-deploy/validated-model',
  storage:
    'https://docs.float16.cloud/getting-started/serverless-gpu/quick-start/app-features/file-storage',
  mode: 'https://docs.float16.cloud/getting-started/serverless-gpu/quick-start/mode',
  quickStart:
    'https://docs.float16.cloud/getting-started/serverless-gpu/quick-start',
};
export const PATH_CONTACT = {
  discord: 'https://discord.gg/j2DVTMjr67',
  support:
    import.meta.env.VITE_PATH_CONTACT_SUPPORT ||
    'https://discord.gg/j2DVTMjr67',
};

export const PATH_EXTERNAL = {
  huggingFace: 'https://huggingface.co/',
  huggingFaceModel: 'https://huggingface.co/models',
};

export const PATH_EXAMPLE =
  'https://github.com/float16-cloud/examples/tree/main';

export const END_POINT_LLM_SERVICE = import.meta.env.VITE_END_POINT_LLM_SERVICE;
export const END_POINT_LLM_SERVICE_CHAT = `${
  import.meta.env.VITE_END_POINT_LLM_SERVICE
}chat/completions`;

export const GOOGLE_ANALYTICS_ID = import.meta.env.VITE_ANALYTICS_ID;

export const MODE = import.meta.env.MODE;
// export const IS_DEV = import.meta.env.MODE === 'development';
export const IS_DEV = false;

export const STRIPE_LOGIN_URL = import.meta.env.VITE_STRIPE_LOGIN_URL;

export const ENDPOINT_LLM = resolve(
  'v1',
  import.meta.env.VITE_BACKEND_API_URL
);
